import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getLeaveManagerReqStart,
  getLeaveManagerReqSuccess,
  getLeaveManagerReqFailed,
} from "../redux/getLeaveManagerReq";
import { getLeaveManagerReqApi } from "core/http/service/timeKeeping";
import { toast } from "react-toastify";
import { selectFormLeaveManagerReq } from "../redux/selector";
import { formReqLeaveUpdate } from "../redux/formReqLeave";
import { listApprover } from "../components/CustomCalendarTimeKeeping/const";

function* getLeaveManagerReqWork() {
  const formData = yield select(selectFormLeaveManagerReq);

  if (!formData?.length) {
    yield put({
      type: getLeaveManagerReqSuccess.type,
      payload: [],
    });
    yield put({
      type: formReqLeaveUpdate.type,
      payload: {
        approvals: [],
      },
    });
    return;
  }
  try {
    const res = yield call(getLeaveManagerReqApi, { details: formData });
    yield put({
      type: getLeaveManagerReqSuccess.type,
      payload: res,
    });
    let listApproverCode = {};
    res.forEach((item, index) => {
      listApproverCode = {
        ...listApproverCode,
        [listApprover[index]]: item.employeeCode,
      };
    });
    yield put({
      type: formReqLeaveUpdate.type,
      payload: {
        approvals: res?.map((it) => ({
          ...it,
          label: `${it?.name || ""} - ${it?.positionName || ""}`,
          value: it?.employeeCode || "",
        })),
        ...listApproverCode,
      },
    });
  } catch (error: any) {
    yield put({
      type: getLeaveManagerReqFailed.type,
    });
    toast.error(error?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetLeaveManagerReq() {
  yield takeLatest(getLeaveManagerReqStart.type, getLeaveManagerReqWork);
}

export default function* getLeaveManagerReqSaga() {
  yield all([watchGetLeaveManagerReq()]);
}
